export default __webpack_public_path__ + "static/media/lds-logo_et.c17a720921dcb4ff.svg";